// HeaderTop.jsx

import React from 'react';
import { Paper } from '@mui/material';
import {
  headerTopPropTypes,
  headerTopDefaultProps,
} from './HeaderTop.propTypes';
import TypographyBlock from '../typography_block/typographyblock';

/**
 * HeaderTop Component
 * A header component with a gradient background, displaying a paragraph of text.
 *
 * @param {string} background - The background color or gradient for the Paper component.
 * @param {string} height - The height of the Paper component.
 * @param {string} paragraph - The text content for the TypographyBlock component.
 * @returns {JSX.Element} The rendered HeaderTop component.
 */
function HeaderTop({ background, height, paragraph }) {
  return (
    <Paper
      sx={{
        background: background,
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRadius: '0',
        '& .MuiTypography-root': {
          fontFamily: 'body.fontFamily.primary',
          fontSize: '20px',
          fontWeight: '400',
          paddingRight: '2.5rem',
          lineHeight: '23.44px',
          paddingTop: '0',
        },
      }}
    >
      <TypographyBlock
        paragraphChildren={
          <a href={`tel:${paragraph.replace(/\./g, '-')}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            {paragraph}
          </a>
        }
        paragraphColor="text.secondary"
      />
    </Paper>
  );
}

// Apply prop types and default props
HeaderTop.propTypes = headerTopPropTypes;
HeaderTop.defaultProps = headerTopDefaultProps;

export default HeaderTop;
